module.exports = __webpack_public_path__ + "img/2.fae7f006.png";